import Component, {TagName, Template} from "./Component";
import {$each, $if} from "./Templating";
import Timing from "./Timing";

import QualitySlideshow from "./QualitySlideshow";

interface IButton {
	buttonDestination: string;
	buttonText: string;
}

interface SlideData {
	image: string;
	captionHeading: string;
	captionSubheading: string;

	buttons: IButton[];
}

export {SlideData};

const slideView = (slide: QualitySlide) => `
	<div class="container">
		${ $if(slide.data.captionHeading, () => `
			<div class="caption">
				${ slide.data.captionSubheading ?
					`<h2 class="caption-subheading">${ slide.data.captionSubheading }</h2>` :
					`` }

				<h1 class="caption-heading">${ slide.data.captionHeading }</h1>
				<div class="button-wrapper">
					${ $each(slide.data.buttons, button => `
						${ $if(button.buttonDestination && button.buttonText, () => `
							<a href="${ button.buttonDestination }" class="button">${ button.buttonText }</a>
						`) }
					`) }
				</div>
			</div>
		`) }
	</div>
`;

@TagName("quality-slide")
@Template(slideView)
export default class QualitySlide extends Component {
	$parent: QualitySlideshow;

	data: SlideData;

	constructor(params: SlideData) {
		super(params);

		this.data = params;
	}

	$hydrate() {
		super.$hydrate();

		this.$element.style.backgroundImage = `url(${ this.data.image })`;
	}

	goOut() {
		this.$element.setAttribute("data-state", "out");
		this.$element.setAttribute("aria-hidden", "true");
	}

	goIn() {
		this.$element.setAttribute("data-state", "in");
		this.$element.removeAttribute("aria-hidden");
	}

	prepToGoIn() {
		return Timing.frame()
			.then(() => {
				this.$element.style.transitionDuration = "0s";
				this.$element.style.transitionDelay = "0s";

				return Timing.frame();
			})
			.then(() => {
				this.goOut();

				return Timing.frame();
			})
			.then(() => {
				this.$element.style.transitionDuration = "";
				this.$element.style.transitionDelay = "";
			});
	}
}
